/**
 * ExecutiveOfficeLocation
 *
 * Location wrapper for the Finance view.
 * Maps to the "Finance" tab in the original navigation.
 */

import React from 'react';
import { CampusLocation } from '../../types/spatial';
import LocationWrapper from '../spatial/LocationWrapper';
import { FinanceView } from '../tycoon/FinanceView';

export type ExecutiveOfficeLocationProps = React.ComponentProps<typeof FinanceView>;

export const ExecutiveOfficeLocation: React.FC<ExecutiveOfficeLocationProps> = (props) => {
  return (
    <LocationWrapper
      location={CampusLocation.EXECUTIVE_OFFICE}
      title="Executive Office"
    >
      <FinanceView {...props} />
    </LocationWrapper>
  );
};

export default ExecutiveOfficeLocation;
